import { useV2DeleteReleaseFlagMutation } from "@generated";

const useDeleteReleaseFlag = () => {
  const [deleteReleaseFlag, state] = useV2DeleteReleaseFlagMutation();

  const deleteMany = async (ids: number[]): Promise<void> => {
    await Promise.all(ids.map((id) => deleteReleaseFlag({ id }).unwrap()));
  };

  return { deleteMany, isLoading: state.isLoading };
};

export default useDeleteReleaseFlag;
